import React, { createContext, useState, useEffect, useContext, ReactNode } from 'react';
import { useLocation,useParams } from 'react-router-dom';
import { fetchLayoutBySlug, ILayout } from '../app/services/layoutService'; 

const defaultTheme: ILayout = {
  logoUrl: process.env.REACT_APP_LOGO_PATH || '/BPO/logomarca.png',
  corPrincipal: process.env.REACT_APP_COR_PRINCIPAL || '#5a8e91',
  corSecundaria: process.env.REACT_APP_COR_SECUNDARIA || '#3d6062',
  corTexto: process.env.REACT_APP_COR_TEXTO || '#F1F1F1',
  corCabecalho: process.env.REACT_APP_COR_FUNDO_HEADER || '#282c34',
  corTabela: process.env.REACT_APP_COR_FUNDO_TABLE || '#24393A',
};

interface ILayoutContext {
  layout: ILayout;
  loading: boolean;
}

const LayoutContext = createContext<ILayoutContext>({
  layout: defaultTheme,
  loading: true,
});

type LayoutProviderProps = {
  children: ReactNode;
};

export const LayoutProvider = ({ children }: LayoutProviderProps) => {
  const [layout, setLayout] = useState<ILayout>(defaultTheme);
  const [loading, setLoading] = useState(true);


  const { slug } = useParams<{ slug?: string }>();
  useEffect(() => {
    const loadLayout = async () => {
      setLoading(true);
      try {
        if (!slug || slug.toLowerCase() === 'fictor') {
          setLayout(defaultTheme);
        } else {
          const layoutData = await fetchLayoutBySlug(slug);
          setLayout(layoutData);
        }
      } catch (error) {
        console.error("Erro no Layout", error);
        setLayout(defaultTheme);
      } finally {
        setLoading(false);
      }
    };

    loadLayout();
  }, [slug]);

  const value = { layout, loading };

  return (
    <LayoutContext.Provider value={value}>
      {children}
    </LayoutContext.Provider>
  );
};

export const useLayout = () => {
  return useContext(LayoutContext);
};